import { config } from '@rematter/config';
import { OrganizationSortOption } from '@rematter/frontend-lib-api-client';
import { maybe } from '@rematter/ui-web';

import { organizationListQueryAtom } from '../_graphql/queryOrganizationList';

import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchParam = atomFromQueryString.string('q');
export const $limit = atomFromQueryString.number('limit', config.pageSize);
export const $offset = atomFromQueryString.number('offset', 0);
export const $sortBy = atomFromQueryString.string<OrganizationSortOption>(
  'sortBy',
  'NameAsc',
);

// 🟢🟢🟢 REMOTE DATA
export const $organizations = organizationListQueryAtom((get) => ({
  variables: {
    searchTerm: get($searchParam),
    sortBy: get($sortBy),
    pagination: maybe(get($limit), (limit) => ({
      limit,
      offset: get($offset) ?? 0,
    })),
  },
}));
